import React from "react";
import { Divider, Typography, Card } from "antd";
import ViewActiveKanban from "../../components/Report/ActiveKanban/ViewActiveKanban";
import "../../styles/global-ui.css";

const ActiveKanban = ({ userData }) => {
  return (
    <div className="page-container">
      
      {/* ================= HEADER ================= */}
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Sewing Out Kanban
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Monitor live kanban movement and status
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      {/* ================= MAIN CONTENT ================= */}
      <Card className="modern-card">
        <ViewActiveKanban userData={userData} />
      </Card>

    </div>
  );
};

export default ActiveKanban;